import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';
import { ModalResult, CreateOrganizationModalComponent as ModalComponent } from './create-organization-modal.component';

@Injectable({ providedIn: 'root' })
export class CreateOrganizationModalService {
  constructor(private modalService: ModalService) {}

  open(options?: NgbModalOptions) {
    return this.modalService.open<ModalResult>(ModalComponent, null, options);
  }
}
